import { getStore } from '../store/store';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { type HelpRibbonTabId } from 'owa-ribbon-ids/lib/helpControlId';

export function getSelectedTab(targetWindow: Window = window): MailRibbonTabId | HelpRibbonTabId {
    return getStore().selectedTabMultiWindow.get(targetWindow) || 1;
}
